module.exports = __webpack_public_path__ + "static/media/flria shot 17.f114cd24.webp";